// extracted by mini-css-extract-plugin
module.exports = {"previewTitle":"RightSectionPage_previewTitle__W5v9P","previewImage":"RightSectionPage_previewImage__2QFWU"};